<template>
  <div class="journal-detail row" v-if="journal">
    <section-header tag="h1" class="mt-5" :title="journal.title" :subtitle="util.getDateStr(journal.addTime * 1000)"/>
    <section :class="photoLayouts ? 'col-md-5' : 'col-md-12'" class="mt-5">
      <div class="content" v-html="journal.content"></div>
    </section>
    <section class="col-md-7 mt-5" v-if="photoLayouts">
      <template v-for="(layout, indexLayout) in photoLayouts">
        <div class="row" :key="indexLayout" v-if="layout.items.length <= 3">
          <div v-for="(item, indexUrl) in layout.items" :key="indexUrl" class="mt-3" :class="`col-${parseInt(12 / layout.items.length)}`">
            <img class="w-100" :src="util.getImageUrl(item.imgOriginal)">
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import journalApi from '@/api/journal.js'
import SectionHeader from '@/components/SectionHeader.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'JournalDetail',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      journal: null,
      gallery: null
    }
  },
  computed: {
    util: function () {
      return util
    },
    journalId: function () {
      return this.$route.params.id ? this.$route.params.id : null
    },
    photoLayouts: function () {
      if (!this.gallery || !this.gallery.length) {
        return null
      }
      var ret = []
      this.gallery.forEach(e => {
        var layout = ret.find(l => (l.groupId === e.groupId))
        if (layout) {
          layout.items.push(e)
        } else {
          ret.push({ groupId: e.groupId, items: [e] })
        }
      })
      ret.forEach(e => { e.items.sort((a, b) => (a.sortOrder - b.sortOrder)) })
      return ret
    }
  },
  mounted: function () {
    this.apiGetJournal()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetJournal: function () {
      var self = this
      if (isNaN(this.journalId)) {
        journalApi.getJournalByLink(this.journalId, function (err, rspData) {
          if (err) {
            if (err === constant.API_ERR_AUTH) {
              self.signOut()
            } else {
              alert(`${err}: ${rspData}`)
            }
            return
          }
          self.journal = rspData
          self.apiGetJournalGallery()
        })
      } else {
        journalApi.getJournal(Number(this.journalId), function (err, rspData) {
          if (err) {
            if (err === constant.API_ERR_AUTH) {
              self.signOut()
            } else {
              alert(`${err}: ${rspData}`)
            }
            return
          }
          self.journal = rspData
          self.apiGetJournalGallery()
        })
      }
    },
    apiGetJournalGallery: function () {
      var self = this
      journalApi.getJournalGallery(self.journal.articleId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.gallery = rspData
      })
    }
  }
}
</script>

<style scoped>
.journal-detail .content >>> h1 {
  font-size: 44px;
  font-weight: 700;
}
.journal-detail .content >>> h2 {
  font-size: 32px;
  font-weight: 700;
}
.journal-detail .content >>> h3 {
  font-size: 25px;
  font-weight: 500;
}
.journal-detail .content >>> h6 {
  font-size: 16px;
  font-weight: 400;
}
.journal-detail .content {
  font-size: 19px;
  font-weight: 400;
}
</style>
